import { render, staticRenderFns } from "./ModalCreateIdeologia.vue?vue&type=template&id=96bb34aa&scoped=true&"
import script from "./ModalCreateIdeologia.vue?vue&type=script&lang=js&"
export * from "./ModalCreateIdeologia.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bb34aa",
  null
  
)

export default component.exports